import { createFileRoute } from '@tanstack/react-router'

import { ReceiveQuotePage } from '../../components/pages/receive-quote-page.tsx'

export const Route = createFileRoute('/receive-quote')({
  component: () => <ReceiveQuotePage version={2} />,
})
